import { render, staticRenderFns } from "./ChatModule.vue?vue&type=template&id=605e1522"
import script from "./ChatModule.vue?vue&type=script&lang=js"
export * from "./ChatModule.vue?vue&type=script&lang=js"
import style0 from "./ChatModule.vue?vue&type=style&index=0&id=605e1522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports